document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-leadtime-root]').forEach(function (root) {
    var select = root.querySelector('[data-leadtime-selector]');
    var leadtimeValue = root.querySelector('[data-leadtime-value]');
    var shippingValue = root.querySelector('[data-shipping-value]');
    var totalEstimate = root.querySelector('[data-total-estimate]');
    var productPrice = Number(root.getAttribute('data-product-price')) || 0;

    if (!select) return;

    select.addEventListener('change', function () {
      var selected = select.options[select.selectedIndex];
      var leadtime = selected.getAttribute('data-leadtime');
      var fee = Number(selected.getAttribute('data-shipping-fee')) || 0;
      var total = productPrice + fee;

      if (leadtimeValue) leadtimeValue.textContent = leadtime;
      if (shippingValue) shippingValue.textContent = fee.toLocaleString('ja-JP') + '円';
      if (totalEstimate) totalEstimate.textContent = Math.round(total).toLocaleString('ja-JP') + '円';
    });
  });
});
